import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import GoldPriceTable from '@/components/feature/GoldPriceTable';
import PriceChart from '@/components/feature/PriceChart';
import CandlestickChart from '@/components/feature/CandlestickChart';
import { goldTypes, candlestick30d } from '@/mocks/goldPrices';
import PriceChange from '@/components/base/PriceChange';

const categories = ['Tất cả', 'Vàng miếng', 'Vàng nhẫn', 'Vàng 24K', 'Vàng 18K'];

export default function Market() {
  const [active, setActive] = useState('Tất cả');
  const [search, setSearch] = useState('');

  const filtered = goldTypes.filter((g) => {
    const matchCat = active === 'Tất cả' ? true : g.name.includes(active.replace('Vàng ', '')) || (active === 'Vàng miếng' && g.name.includes('miếng')) || (active === 'Vàng nhẫn' && g.name.includes('nhẫn') || g.name.includes('Nhẫn'));
    const matchSearch = g.name.toLowerCase().includes(search.toLowerCase()) || g.code.toLowerCase().includes(search.toLowerCase());
    return matchCat && matchSearch;
  });

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-16">
        <div className="border-b border-background-200/60 bg-background-100">
          <div className="mx-auto max-w-6xl px-4 md:px-6 py-10">
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-950">Thị trường vàng</h1>
            <p className="mt-2 text-foreground-600">Cập nhật giá vàng trong nước theo thời gian thực · 15/08/2026</p>
          </div>
        </div>

        <div className="mx-auto max-w-6xl px-4 md:px-6 py-8">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
            <div className="flex flex-wrap items-center gap-1 p-1 rounded-full bg-background-100 border border-background-200/60">
              {categories.map((c) => (
                <button
                  key={c}
                  onClick={() => setActive(c)}
                  className={`px-4 py-1.5 rounded-full text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors ${
                    active === c ? 'bg-primary-500 text-background-950' : 'text-foreground-600 hover:text-foreground-900'
                  }`}
                >
                  {c}
                </button>
              ))}
            </div>
            <div className="relative w-full md:w-72">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-500 text-sm"></i>
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Tìm loại vàng..."
                className="w-full pl-9 pr-4 py-2.5 rounded-md bg-background-100 border border-background-300/60 text-sm text-foreground-900 placeholder:text-foreground-500 focus:outline-none focus:border-primary-500"
              />
            </div>
          </div>

          <GoldPriceTable />

          <div className="mt-8 rounded-xl border border-background-200/60 overflow-hidden">
            <div className="bg-[#131722] p-4 md:p-5">
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-2">
                <div>
                  <h3 className="text-sm font-semibold text-[#d1d4dc]">Biểu đồ nến giá vàng SJC</h3>
                  <p className="text-xs text-[#787b86]">Đơn vị: VNĐ / lượng · 30 ngày</p>
                </div>
                <div className="inline-flex rounded-full border border-[#2B2B43] p-1 bg-[#1e222d]">
                  <button className="px-4 py-1.5 rounded-full text-xs font-semibold whitespace-nowrap bg-[#2962ff] text-white cursor-pointer">
                    30 ngày
                  </button>
                </div>
              </div>
              <CandlestickChart data={candlestick30d} height={380} />
            </div>
          </div>

          <div className="mt-8">
            <PriceChart />
          </div>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {goldTypes.slice(0, 4).map((g) => (
              <div key={g.id} className="rounded-xl border border-background-200/60 bg-background-100 p-5">
                <div className="flex items-center justify-between mb-3">
                  <span className="text-sm font-semibold text-foreground-950">{g.code}</span>
                  <PriceChange change={g.change} changePercent={g.changePercent} showPercent={false} />
                </div>
                <p className="text-xs text-foreground-600">Giá bán</p>
                <p className="text-lg font-bold text-foreground-950 whitespace-nowrap">{g.sell.toLocaleString('vi-VN')}đ</p>
              </div>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}